import { render, staticRenderFns } from "./task.vue?vue&type=template&id=6baaa526&scoped=true"
import script from "./task.vue?vue&type=script&lang=ts&setup=true"
export * from "./task.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./task.vue?vue&type=style&index=0&id=6baaa526&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baaa526",
  null
  
)

export default component.exports